import React, { useContext, useState, useEffect } from 'react'
import { login } from '../../context/authContext/apiCalls';
import { AuthContext } from '../../context/authContext/AuthContext';
import FormInput from '../../components/formInput/FormInput';
import RightLoginRegister from '../../components/rightLoginRegister/RightLoginRegister';
import { Link } from 'react-router-dom';
import './login.css';

function Login() {
  const [errorBox, setErrorBox] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { dispatch, isFetching, error } = useContext(AuthContext);

  useEffect(() => {
    dispatch({ type: "REGISTER_CLEAR", });
  },[])
  
  useEffect(() => {
    if (error != false) {
      setErrorBox(error);
    }
  }, [error])

  const loginHandler = (e)=>{
    e.preventDefault();
    login(dispatch, {username, password});
  }

  return (
    <div className="container">
      <div className="box">
        <div className="logo">
          <img src="/logo.png" alt="" />
        </div>
        <form action="">
          <h1>Se Connecter</h1>

          {errorBox !== "" && (<div className='box-error'>{errorBox}</div>)}
          {/* {mess !== "" && (<div className='box-success'>{mess}</div>)} */}

          <FormInput label='Username *' itemInput={username} setItemInput={setUsername} auth />
          <FormInput label='Password *' itemInput={password} setItemInput={setPassword} auth isPassword />

          <button onClick={loginHandler} style={isFetching ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
            <span>{isFetching ? "Se Connecter ..." : "Se Connecter"}</span>
          </button>
          <p>
            Vous n'avez pas un compte ? <Link to={"/register"}>Créer un Compte</Link>
          </p>
        </form>
      </div>

      <RightLoginRegister />
    </div>
  )
}

export default Login
